<template>
	<div class="bg-grey-11 text-white text-xs rounded-xl p-4">
		<div class="flex items-center gap-4 mb-5">
			<div>
				<img src="@/assets/img/pool-gold-icon.png" alt="" class="img-gold w-5">
			</div>
			<div>
				<div class="text-grey">{{ contractConfigs.codeName }}</div>
				<div class="font-bold">{{ contractConfigs.name }}</div>
			</div>
		</div>

		<div class="flex justify-between gap-2 text-2xs mb-4">
			<div>
				<div class="text-grey font-semibold">Low</div>
				<div>{{ lowShown }}</div>
			</div>
			<div>
				<div class="text-grey font-semibold">%Change</div>
				<div>{{ changeShown }}</div>
			</div>
			<div>
				<div class="text-grey font-semibold">High</div>
				<div>{{ highShown }}</div>
			</div>
		</div>

		<hr class="border border-grey-10 mb-4 mx--4" />

		<div v-if="contractConfigs.isSoon" class="text-center bg-grey-12 rounded-lg text-gold2 font-bold py-5">
			SOON
		</div>

		<div v-else class="flex items-center text-center gap-1">
			<div class="flex-1 border border-solid border-red rounded-lg py-2 cursor-pointer" @click="clickButton('sell')">
				<div class="font-bold">SELL</div>
				<div>{{ sellShown }}</div>
			</div>
			<div class="flex-1 border border-solid border-green rounded-lg py-2 cursor-pointer" @click="clickButton('buy')">
				<div class="font-bold">BUY</div>
				<div>{{ buyShown }}</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Decimal } from 'decimal.js'
import { EVENT_KEYS } from '../internal/events'

export default {
	name: 'TradeBoxV2',
	props: {
		width: {
			type: Number,
			default: 160
		},
		height: {
			type: Number,
			default: 0
		},
		add_class: {
			type: String,
			default: ''
		},

		contractId_prop: {
			type: Number,
			default: 1
		},

		showGoldDrip: {
			type: Boolean,
			default: false,
		},

		clickAble: {
			type: Boolean,
			default: true,
		},
	},

	computed: {
		EVENT_KEYS() {
			return EVENT_KEYS
		},

		currency() {
			return this.$store.state.currency
		},

		streamingRate() {
			return this.$store.getters.getStreamingRate
		},

		gold() {
			return this.$store.getters.getGoldByContractId(this.contractId_prop)
		},

		ohlc() {
			return this.$store.getters.getOhlcByContractId(this.contractId_prop)
		},

		contractConfigs() {
			return this.$store.getters.getContractConfigs(this.contractId_prop)
		},

		sellShown() {
			if (!this.gold) {
				return '-'
			}

			let sellPrice = new Decimal(this.gold.sell)

			if (this.currency == "idr") {
				sellPrice = sellPrice.times(this.streamingRate.streamSell)
			}

			return this.numberFormatExtend(sellPrice.toDecimalPlaces(this.contractConfigs.tbTtDecimalPlace).toNumber(), this.contractConfigs.tbTtDecimalPlace)
		},
		buyShown() {
			if (!this.gold) {
				return '-'
			}

			let buyPrice = new Decimal(this.gold.buy)

			if (this.currency == "idr") {
				buyPrice = buyPrice.times(this.streamingRate.streamBuy)
			}

			return this.numberFormatExtend(buyPrice.toDecimalPlaces(this.contractConfigs.tbTtDecimalPlace).toNumber(), this.contractConfigs.tbTtDecimalPlace)
		},

		style_tradebox() {
			return (`
					
				`)
		},
		style_percentage() {
			return 'color: ' + (this.caret_direction == 'up' ? 'green;' : 'red;')
		},

		caret() {
			if (!this.ohlc) {
				return '-'
			}

			return this.ohlc.caretDirection
		},

		lowShown() {
			if (!this.ohlc) {
				return '-'
			}

			let lowPrice = new Decimal(this.ohlc.low).toDecimalPlaces(2)

			if (this.currency == 'idr') {
				lowPrice = lowPrice.times(this.ohlc.rate)
			}

			return this.numberFormatExtend(lowPrice.toNumber())
		},
		highShown() {
			if (!this.ohlc) {
				return '-'
			}

			let highPrice = new Decimal(this.ohlc.high).toDecimalPlaces(2)

			if (this.currency == 'idr') {
				highPrice = highPrice.times(this.ohlc.rate)
			}

			return this.numberFormatExtend(highPrice.toNumber())
		},

		change() {
			if (!this.gold || !this.ohlc) {
				return '-'
			}

			const pricePerGram = new Decimal(this.gold.contractPriceBuy).dividedBy(this.contractConfigs.weightCorrection)
			const change = pricePerGram.minus(this.ohlc.open).dividedBy(this.ohlc.open).times(100).toDecimalPlaces(2).toNumber()

			return change
		},
		changeShown() {
			if (this.change == '-') {
				return '-'
			}

			const change = new Decimal(this.change)
			const sign = change.isNegative() ? '-' : '+'

			return sign + this.numberFormatExtend(change.abs().toDecimalPlaces(2).toNumber())
		},

		isEventRogActive() {
			const eventStatus = this.$store.getters['events/getEventStatus'](EVENT_KEYS.rog)

			return eventStatus == 'ongoing' ? true : false
		}
	},

	created() {
		// fetch ROG event detail
		if (this.$store.getters.paymentMethod == 'rped') {
			this.$store.dispatch('events/fetchEvent', EVENT_KEYS.rog)
		}
	},

	methods: {
		showSomething() { //for QA purpose. only dev
			if (process.env.NODE_ENV === 'production') return

			const style = 'background-color: darkblue; color: white; font-style: italic; border: 5px solid hotpink; font-size: 2em;'
			console.log("%c😭😭😭😢😢😢", style,
				"\n\n",
				"Contract ID: ", this.contractId_prop, "\n",
				"Contract Name: ", this.contractConfigs.name, "\n",
				"Rate OHLC: ", (this.ohlc || {}).rate || '-', "\n",
				"Rate Now: ", this.streamingRate.streamBuy, "\n",
				"Berat Kontrak: ", this.contractConfigs.weightMultiplication, "\n\n",
				"Contract Price Buy now: ", this.gold.contractPriceBuy, "\n",
				"Open BE: ", ((this.ohlc || {}).original || {}).open || '-', "\n",
				"Close BE: ", ((this.ohlc || {}).original || {}).close || '-', "\n",
				"Low BE: ", ((this.ohlc || {}).original || {}).low || '-', "\n",
				"High BE: ", ((this.ohlc || {}).original || {}).high || '-', "\n\n",

				"High: ", this.highShown, "\n",
				"Low: ", this.lowShown, "\n",
				"Change: ", this.changeShown, "\n",

				"High IDR: ", Decimal.mul(new Decimal((this.ohlc || {}).high || 0).toDecimalPlaces(2), (this.ohlc || {}).rate || 0).toNumber(), "\n",
				"Low IDR: ", Decimal.mul(new Decimal((this.ohlc || {}).low || 0).toDecimalPlaces(2), (this.ohlc || {}).rate || 0).toNumber(), "\n",
			)
		},

		clickButton(direction) {
			this.$emit('clickButton', direction)
		}
	},

}
</script>

<style>
.img-gold {
	clip-path: circle();
	background: linear-gradient(225deg, #FE9A00 0.78%, #985C00 100.78%);
}
</style>